import React, {useCallback, useMemo, useState} from "react";

import {useFeedbackTools} from "../../../../components/FeedbackTools";
import {useAccommodationsPage} from "../../AccommodationContext";
import ServiceList, {serviceState} from "../../ServiceList";
import {useHome} from "../HomeContext";

const HomeServices = () => {
    const {homeServices: allServices} = useAccommodationsPage();
    const {serviceJoins, updateHomeServiceJoins} = useHome();
    const  [isLoading, setIsLoading] = useState(false);
    const {showErrorNotification, showSuccessNotification} = useFeedbackTools();

    const services = useMemo(
        () => allServices.map(({id, nameIt}) => {
            const selected = serviceJoins.find(s => s.homeServiceId === id);
            return {
                id: id,  // id of the home service
                name: nameIt,  // Name of the home service
                group: 0, // no group is used
                homeServiceJoinId: selected ? selected.id : null,
            }
        }),
        [allServices, serviceJoins]
    )

    const getServiceState = useCallback(
        (service) => {
            const selected = serviceJoins.find(s => s.homeServiceId === service.id);
            return selected ? (selected.withFee ? serviceState.withFee : serviceState.present) : serviceState.absent;
        },
        [serviceJoins]
    )

    const handleSave = async (services) => {
        const newServiceJoinsList = services
            .filter(s => s.state !== serviceState.absent)
            .map(s => ({
                id: s.homeServiceJoinId,
                homeServiceId: s.id,
                withFee: s.state === serviceState.withFee,
            }))

        setIsLoading(true);
        try{
            await updateHomeServiceJoins(newServiceJoinsList);
            showSuccessNotification("Salvataggio completato");
        }catch(e){
            showErrorNotification(e);
        }
        setIsLoading(false);
    }

    return <ServiceList services={services}
                        onSave={handleSave}
                        getServiceState={getServiceState}
                        isLoading={isLoading}/>

}

export default HomeServices;